// eslint-disable-next-line
export const ACTIONS_NAMESPACE = '@@CB';
